import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";
import Discussion from "@/components/DiscussionForum/DiscussionForum.vue";
import { reactive } from "vue";
// import html2pdf from 'html2pdf.js';

import { client_domain } from "@/main.js";

export default {
    props: {
        is_public: {
            type: Boolean,
            default: false,
        },
        portal_admin: {
            type: Boolean,
            default: false,
        },
        active_profile: {
            type: Object,
            default: null,
        },
    },
    components: {
        Discussion
    },
    mounted() {
        this.token_exists = get_token();
        this.user_id = this.get_user_id();
        this.user_details = get_user_details();
        this.get_question_types();
        this.filter_surveys();
        this.filter_polls();

        this.fetchQuestions();

        if (client_domain.includes('soulcity') || client_domain.includes('nsp')) {
            this.soulcity_domain = true;
        }
    },

    data() {

        return ({
            selectedSurveyId: null,
            token_exists: false,
            surveys: [],
            activeVoiceTab: 'discussions',
            survey_name: '',
            survey_description: '',
            survey_end_date: '',
            questions: [],
            showQuestionsForm: true,
            errors: [],
            firstErrorQuestionId: null,
            pollErrors: [],
            firstPollErrorQuestionId: null,
            answers: {},
            showResponsesFor: null,
            filteredQuestions: [],
            survey_survey_selectname: "",
            selectedQuestions: [],
            description: "",
            showQuestionForm: false,
            newQuestion: {
                text: '',
                question_number: '',
                type: '',
                options: [],
                is_mandatory: false,
            },
            question_types: [],
            showSelectedQuestions: false,
            createdQuestions: [],
            survey_questions: [],
            portal_id: null,
            selectedPollId: null,
            polls: [],
            poll_name: '',
            poll_description: '',
            expandedQuestions: new Map(),
            allowMultiple: false,
            options: [
                { value: '' },
                { value: '' },
                { value: '' }
            ],
            selectedPoll: null,
            numberErrors: {},
            soulcity_domain: false,
            user_details: {
                "user_role": '',
                "user_id": '',
            },
            openOptions: new Map(),
            flipped_id: null,

        })
    },
    computed: {
        now_date_time_local() {
            return this.format_date_time(new Date(), 'T');
        },
        filteredSurveys() {
            const currentUserId = this.user_details?.id || this.user_id;
            return this.surveys.map(survey => ({
                ...survey,
                survey_questions: survey.survey_questions.map(q => ({
                    ...q,
                    answers: (q.answers || []).filter(
                        a => a.user?.id === Number(currentUserId)
                    )
                }))
            }));
        }
    },
    methods: {
        getToken() {
            return get_token();
        },
        format_date_time(value, separator = 'T') {
            if (!value) return '';

            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return '';
            }

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day}${separator}${hours}:${minutes}`;
        },
        // Helper methods for readability
        isMultipleChoice(question) {
            return question.question.question_type.question_type === 'selection';
        },
        isSingleChoice(question) {
            return question.question.question_type.question_type === 'checkbox';
        },
        flip_to(id) {
            this.flipped_id = (this.flipped_id === id) ? null : id;
        },
        unflip() {
            this.flipped_id = null;
        },

        // Initialization
        initializeAnswers() {
            this.answers = new Map(); // reset Map first
            this.polls.forEach(poll => {
                poll.poll_questions.forEach(question => {
                    const type = question.question.question_type.question_type;
                    const id = question.question.id;
                    const answeredOptions = question.answers?.map(a => a.answer) || [];

                    if (type === 'checkbox') {
                        // Single choice
                        this.answers.set(id, answeredOptions[0] || '');
                    } else if (type === 'selection') {
                        // Multiple choice
                        this.answers.set(id, answeredOptions.length ? answeredOptions : []);
                    } else {
                        // Handle other types if needed
                        this.answers.set(id, '');
                    }
                });
            });
        },

        // Reactive access for v-model
        getAnswer(questionId) {
            return this.answers ? Reflect.get(this.answers, questionId) ?? null : null;
        },
        setAnswer(questionId, value) {
  // Spread into a new object so Vue detects the change
  this.answers = { ...this.answers, [questionId]: value };
},
getUserAnswer(question) {
  const answers = question.answers || [];

  const user_answer = answers.find(a => a.user?.id === Number(this.user_id));

  if (user_answer) {
    return user_answer;
  }
  return answers[0] || null;
},

        validateNumber(questionId) {
            // Safely get value
            const value = Reflect.get(this.answers, questionId);

            // If empty, clear error
            if (value === "" || value === null || value === undefined) {
                Reflect.set(this.numberErrors, questionId, null);
                return;
            }

            // Check if it’s a valid number
            if (isNaN(value)) {
                Reflect.set(this.numberErrors, questionId, "Please enter a valid number.");
            } else {
                Reflect.set(this.numberErrors, questionId, null);
            }
        },
        get_user_id() {
            const user_id = localStorage.getItem('user_id') || '';
            return user_id;
        },
        survey_is_answered(survey) {
            const value = survey?.is_answered;
            return value === true;
        },
        survey_has_ended(survey) {
            if (!survey?.end_date) {
                return false;
            }

            const endDate = new Date(survey.end_date);
            if (Number.isNaN(endDate.getTime())) {
                return false;
            }

            return endDate < new Date();
        },
        survey_ends_in_text(survey) {
            if (!survey?.end_date || this.survey_has_ended(survey)) {
                return '';
            }

            const endDate = new Date(survey.end_date);
            const now = new Date();
            const diffMs = endDate - now;

            if (Number.isNaN(endDate.getTime()) || diffMs <= 0) {
                return '';
            }

            const diffMinutes = Math.floor(diffMs / (1000 * 60));
            const diffDays = Math.floor(diffMinutes / (60 * 24));
            const diffHours = Math.floor((diffMinutes % (60 * 24)) / 60);
            const remainingMinutes = diffMinutes % 60;

            if (diffDays > 0) {
                return `Ends in ${diffDays}d ${diffHours}h`;
            }

            if (diffHours > 0) {
                return `Ends in ${diffHours}h ${remainingMinutes}m`;
            }

            return `Ends in ${remainingMinutes}m`;
        },
        toggleSurvey(id) {
            this.selectedSurveyId = this.selectedSurveyId === id ? null : id;
        },
        handle_user_survey_card_click(survey) {
            if (!survey) return;

            if (this.survey_is_answered(survey)) {
                survey.showAnswers = !survey.showAnswers;
                return;
            }

            if (this.survey_has_ended(survey)) {
                return;
            }

            this.toggleSurvey(survey.id);
        },
        handle_creator_survey_card_click(survey_id) {
            this.flip_to(survey_id);
        },
        getVotes(question, option) {
            return question.answers.filter(a => a.answer.includes(option.option)).length;
        },
        getTotalVotes(question) {
            return question.answers.length;
        },
        getPercentage(question, option) {
            const total = this.getTotalVotes(question);
            const votes = this.getVotes(question, option);
            if (total === 0) return 0;
            return ((votes / total) * 100).toFixed(1);
        },
        getColor(option) {
            const colors = ["#3b82f6", "#22c55e", "#a855f7", "#f97316", "#06b6d4"];
            const index = option.id % colors.length;
            return colors.at(index);
        },
        toggleOption(questionId, optionId) {
            const safeQid = Number(questionId) || 0;
            const safeOid = Number(optionId) || 0;
            const key = `${safeQid}-${safeOid}`;
            const current = this.openOptions.get(key) || false;
            this.openOptions.set(key, !current);
        },

        isOptionOpen(questionId, optionId) {
            const safeQid = Number(questionId) || 0;
            const safeOid = Number(optionId) || 0;
            const key = `${safeQid}-${safeOid}`;
            return this.openOptions.get(key) || false;
        },
        on_input(index) {
            const lastIndex = this.options.length - 1;

            // Safely get the last option object
            const lastOption = Reflect.get(this.options, lastIndex);

            // Safely get its value
            const lastValue = lastOption ? Reflect.get(lastOption, 'value') : "";

            if (index === lastIndex && lastValue.trim() !== "") {
                // Safely push a new object
                this.options.push({ value: "" });
            }
        },
        toggleSurveyResponses(id) {
            this.showResponsesFor = this.showResponsesFor === id ? null : id;
        },

        submitSurveyAnswers(survey) {

            const formData = new FormData();
            formData.append('survey_id', survey.id);

            const answeredQuestions = [];
            this.errors = [];
            this.firstErrorQuestionId = null;

            const validQuestionIds = Array.isArray(survey.survey_questions)
                ? survey.survey_questions.map(q => q?.question?.id).filter(Boolean)
                : [];

            for (const questionId of validQuestionIds) {
                const answer = Reflect.get(this.answers, questionId);


                const isEmpty =
                    answer === undefined ||
                    answer === null ||
                    (Array.isArray(answer) && answer.length === 0) ||
                    (typeof answer === 'string' && answer.trim() === '');

                if (isEmpty) {
                    if (!this.firstErrorQuestionId) {
                        this.firstErrorQuestionId = questionId;
                    }

                    const exists = this.errors.find(error => error.id === questionId);
                    if (!exists) {
                        this.errors.push({
                            id: questionId,
                            message: 'This question requires an answer.'
                        });
                    }

                    // ✅ Don't return yet — continue checking all questions
                    continue;
                }

                answeredQuestions.push({
                    question_id: Number(questionId),
                    answer: Array.isArray(answer) ? answer.join(',') : answer
                });
            }

            // ✅ After the loop, only stop if there are errors
            if (this.errors.length > 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Incomplete',
                    text: 'Please answer all required questions before submitting.',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                });
                return;
            }

            formData.append('answers', JSON.stringify(answeredQuestions));

            $.ajax({
                type: "POST",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/answer_survey/`,
                headers: {
                    'Authorization': `Token ${this.getToken()}`
                },
                data: formData,
                processData: false,
                contentType: false,
                success: (response) => {
                    if (response.status === 'success') {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Your answers have been submitted successfully!',
                            showConfirmButton: false,
                            timer: 1500,
                            position: 'bottom-end',
                            toast: true
                        });
                        this.selectedSurveyId = null;
                        survey.is_answered = true;
                        survey.showAnswers = true;

                        const currentUserId = this.user_details?.id;
                        const answers = response.data.answers || [];

                        for (const ans of answers) {
                            const questionId = ans.survey_question?.question?.id || ans.survey_question?.id;
                            const q = survey.survey_questions.find(q => q.question.id === questionId);
                            if (q) {
                                if (!q.answers) q.answers = [];
                                const existing = q.answers.find(a => a.user?.id === currentUserId);
                                if (!existing) {
                                    q.answers.push({
                                        id: ans.id,
                                        answer: ans.answer,
                                        user: ans.user,
                                    });
                                }
                            }
                        }
                    }
                },
                error: () => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong. Please try again later.',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                },
                complete: () => {
                    this.showQuestionsForm = false;
                    this.isSubmitting = false;
                },
            });
        },

        filter_surveys() {
            const group_id_param = this.$route.params.group_id;
            const portal_id_param = this.$route.params.portal_id;

            const group_id = group_id_param ? Number(group_id_param) : null;
            const portal_id = group_id ? null : (portal_id_param ? Number(portal_id_param) : null);            

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/filter_survey/`,
                method: 'POST',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({ portal_id, group_id }),
                success: (response) => {
                    this.surveys = response.data;
                },
                complete: () => {
                    this.isLoading = false;
                }
            });
        },

        fetchQuestions() {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
                method: "POST",
                headers: this.token_exists
                    ? { Authorization: `Token ${this.getToken()}` }
                    : {},
                success: (response) => {
                    this.questions = response.data.questions;
                },
            });
        },
        onQuestionInput(event) {
            const inputValue = event.target.value.toLowerCase();
            this.filteredQuestions = this.questions.filter((q) =>
                q && q.question && q.question.toLowerCase().includes(inputValue)
            );
        },
        onQuestionSelect(event) {
            const selectedValue = event.target.value;
            const selectedQuestion = this.questions.find(q =>
                q && q.question && q.question === selectedValue
            );

            if (selectedQuestion) {
                if (this.activeVoiceTab === 'questionpoll') {
                    // For polls, directly fill in the form fields
                    this.newQuestion.text = selectedQuestion.question;
                    this.newQuestion.type = selectedQuestion.question_type.id;

                    // Properly format options with text property
                    if (selectedQuestion.options && selectedQuestion.options.length > 0) {
                        this.newQuestion.options = selectedQuestion.options.map(opt => ({
                            id: opt.id || Date.now() + Math.random(),
                            text: opt.option || opt.text || ''
                        }));
                    } else {
                        this.newQuestion.options = [];
                    }

                    this.newQuestion.is_mandatory = selectedQuestion.is_mandatory || false;
                    this.newQuestion.question_number = selectedQuestion.question_number || '';
                    this.filteredQuestions = [];
                } else {
                    this.selectQuestion(selectedQuestion);
                }
            }
        },

        selectQuestion(question) {
            if (!this.selectedQuestions.some(q => q.id === question.id)) {
                this.selectedQuestions.push(question);
            }

            this.newQuestion.text = question.question;
            this.newQuestion.type = question.question_type.id;
            this.newQuestion.options = question.options || [];
            this.newQuestion.is_mandatory = question.is_mandatory || false;
            this.newQuestion.question_number = question.question_number || '';

            if (!this.createdQuestions.some(q => q.id === question.id)) {
                this.createdQuestions.push({
                    text: question.question,
                    id: question.id,
                    type: question.question_type.id,
                    is_mandatory: question.is_mandatory || false,
                });
            }
            this.filteredQuestions = [];

            this.newQuestion = {
                text: '',
                question_number: '',
                type: '',
                options: [],
                is_mandatory: false,
            };
        },
        validationforSurveyName() {
            this.errors = {};
            let valid = true;
            if (!this.survey_name || this.survey_name.trim() === '') {
                this.errors.survey_name = 'Survey name is required';
                valid = false;
            }
            if (this.survey_end_date) {
                const selectedDate = new Date(this.survey_end_date);
                const now = new Date();
                if (Number.isNaN(selectedDate.getTime()) || selectedDate < now) {
                    this.errors.survey_end_date = `End date and time cannot be in the past. Choose ${this.format_date_time(this.now_date_time_local, ' ')} or later.`;
                    valid = false;
                }
            }
            return valid;
        },
        submit_survey_form() {
            if (!this.validationforSurveyName()) {
                return;
            }
            const group_id = this.$route.params.group_id;
            const portal_id = this.$route.params.portal_id;
            const payload = {
                name: this.survey_name,
                description: this.survey_description,
                end_date: this.survey_end_date || null,
                questions: this.selectedQuestions.map(q => q.id),
                group_id: group_id ? Number(group_id) : null,
                portal_id: group_id ? null : (portal_id ? Number(portal_id) : null),
            };
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/create_survey/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload),
                success: () => {
                    () => {
                        Swal.fire({
                            title: 'Creating survey...',
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading();
                            }
                        });
                    },
                        this.filter_surveys();

                    Swal.fire({
                        icon: 'success',
                        title: 'Survey Created',
                        text: 'Your survey has been successfully created!',
                        showConfirmButton: false,
                        timer: 2000,
                        position: 'bottom-end',
                        toast: true
                    }).then(() => {
                        // Reset form
                        this.survey_name = '';
                        this.survey_end_date = '';
                        this.description = '';
                        this.questions = [];
                        this.selectedQuestions = [];
                        this.createdQuestions = [];
                        this.errors = {};
                        if (this.$refs.quillSurveyEditorRef) {
                            this.$refs.quillSurveyEditorRef.setHTML('');
                        }

                        // Switch to surveys tab
                        this.activeVoiceTab = 'surveys';
                    });
                },
                error: (xhr) => {
                    Swal.close();
                    if (
                        xhr.responseJSON.message
                    ) {
                        this.errors.survey_name = xhr.responseJSON.message;
                        return; // No popup
                    }
                }
            });
        },

        editSurvey(survey) {
            this.survey_id = survey.id;
            this.survey_name = survey.name;
            this.survey_description = survey.description;
            this.survey_end_date = this.format_date_time(survey.end_date, 'T');
            this.showQuestionForm = true;

            this.selectedQuestions = survey.survey_questions.map((q) => ({
                id: q.question.id,
                question: q.question.question,
            }));
            this.survey_survey_selectname = this.selectedQuestions.map((q) => q.question);
            this.createdQuestions = survey.survey_questions.map((q, i) => ({
                id: q.question.id,
                text: q.question.question,
                question_number: i + 1,
                type: q.question.question_type.id,
                options: q.question.options || [],
                is_mandatory: q.question.is_mandatory || false,
            }));

            this.newQuestion = {
                text: '',
                question_number: '',
                type: '',
                options: [],
                is_mandatory: false,
            };

            this.activeVoiceTab = 'questions';
            this.showSurveyCreation = true;

            this.$nextTick(() => {
                if (this.$refs.quillSurveyEditorRef) {
                    this.$refs.quillSurveyEditorRef.setHTML(survey.description || "");
                }
            });
        },

        cancelEdit() {
            this.survey_id = null;
            this.survey_name = '';
            this.survey_end_date = '';
            this.description = '';
            this.selectedQuestions = [];
            this.createdQuestions = [];
            if (this.$refs.quillSurveyEditorRef) {
                this.$refs.quillSurveyEditorRef.setHTML('');
            }

            // Switch back to surveys tab
            this.activeVoiceTab = 'surveys';
        },

        submitSurvey() {
            this.survey_description = this.$refs.quillSurveyEditorRef.getHTML();
            this.survey_description = this.survey_description.replace(/<\/?p>/g, '').trim();

            if (!this.survey_description || this.survey_description === '<br>' || this.survey_description === '<br/>') {
                this.survey_description = '';
            }

            if (!this.validationforSurveyName()) {
                return;
            }

            if (this.newQuestion.text && this.newQuestion.type) {
                this.addQuestionToSurvey()
                    .then(() => {
                        if (this.survey_id) {
                            this.updateSurvey();
                        } else {
                        } this.submit_survey_form();
                    })
                    .catch((error) => {
                        console.error("Error adding question:", error);
                    });
                return;
            }

            if (this.survey_id) {
                this.updateSurvey();
                return;
            }
            this.submit_survey_form();

        },

        updateSurvey() {
            this.survey_description = this.$refs.quillSurveyEditorRef.getHTML();

            this.survey_description = this.survey_description.replace(/<\/?p>/g, '').trim();

            if (!this.survey_description || this.survey_description === '<br>' || this.survey_description === '<br/>') {
                this.survey_description = '';
            }

            if (!this.validationforSurveyName()) {
                return;
            }

            if (this.newQuestion.text && this.newQuestion.type) {

                this.addQuestionToSurvey()
                    .then(() => {
                        this.updateSurveyForm();
                    })
                    .catch((error) => {
                        console.error("Error adding question:", error);
                    });
                return;
            }
            this.updateSurveyForm();
        },
        updateSurveyForm() {
            if (!this.validationforSurveyName()) {
                return;
            }

            const payload = {
                survey_id: this.survey_id,
                name: this.survey_name,
                description: this.survey_description,
                end_date: this.survey_end_date || null,
                questions: this.selectedQuestions.map(q => q.id),
            };

            Swal.fire({
                title: 'Updating survey...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/update_survey/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload),
                success: () => {
                    this.filter_surveys();
                    Swal.fire({
                        icon: 'success',
                        title: 'Survey Updated',
                        text: 'Your survey has been successfully updated!',
                        showConfirmButton: false,
                        timer: 2000,
                        position: 'bottom-end',
                        toast: true
                    }).then(() => {
                        this.survey_id = null;
                        this.survey_name = '';
                        this.survey_end_date = '';
                        this.description = '';
                        this.questions = [];
                        this.selectedQuestions = [];
                        this.createdQuestions = [];
                        if (this.$refs.quillSurveyEditorRef) {
                            this.$refs.quillSurveyEditorRef.setHTML('');
                        }

                        // Switch to surveys tab
                        this.activeVoiceTab = 'surveys';
                    });
                },
                error: () => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Cannot Edit Survey',
                        text: 'This survey has already been answered and cannot be edited.',
                        confirmButtonText: 'OK',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                }

            });
        },
        get_question_types() {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_question_types/`,
                method: "GET",
                headers: { Authorization: `Token ${this.getToken()}` },
                success: (response) => {
                    this.question_types = response.data.question_types;
                },
            });
        },
        removeCreatedQuestion(index) {
            const removed = this.createdQuestions.splice(index, 1)[0];

            this.selectedQuestions = this.selectedQuestions.filter(q => q.id !== removed.id);
        },
        toggleCheckboxAnswer(survey, questionId, option, isChecked) {
            // Ensure answers is a reactive object
            if (!this.answers || typeof this.answers !== 'object') {
                this.answers = reactive({});
            }

            const qId = String(questionId); // normalize key to string

            // Get current answers safely
            let currentAnswers = Reflect.get(this.answers, qId);
            if (!Array.isArray(currentAnswers)) {
                currentAnswers = [];
            }

            let updatedAnswers = [...currentAnswers];

            if (isChecked) {
                // Add option if not already in the array
                if (!updatedAnswers.includes(option)) {
                    updatedAnswers.push(option);
                }
            } else {
                // Remove option if unchecked
                updatedAnswers = updatedAnswers.filter(a => a !== option);
            }

            // Set updated array safely
            Reflect.set(this.answers, qId, updatedAnswers);

            // No need to spread {...this.answers} — reactivity works with Vue 3 objects
        },
        saveAnswer(survey, questionId, value) {
            this.survey_questions = survey.survey_questions;
            const question = this.survey_questions.find(q => q.question.id === questionId);
            if (question) {
                question.answer = value;
            }
        },
        addQuestionToSurvey() {
            return new Promise((resolve, reject) => {
                if (!this.newQuestion.text || !this.newQuestion.type || !this.newQuestion.question_number) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Missing Information',
                        text: 'Please fill in all required fields for the question',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                    reject('Missing required fields');
                    return;
                }

                // Check if the question already exists
                const existingQuestion = this.questions.find(q => q.question === this.newQuestion.text);
                if (existingQuestion) {
                    if (!this.selectedQuestions.some(q => q.id === existingQuestion.id)) {
                        this.selectedQuestions.push(existingQuestion);
                        this.createdQuestions.push({
                            text: existingQuestion.question,
                            id: existingQuestion.id,
                            type: existingQuestion.question_type.id,
                            is_mandatory: existingQuestion.is_mandatory || false,
                        });
                    }
                    this.newQuestion = {
                        text: '',
                        question_number: '',
                        type: '',
                        options: [],
                        is_mandatory: false,
                    };

                    Swal.fire({
                        icon: 'success',
                        title: 'Question Added',
                        text: 'Existing question has been added to your survey',
                        showConfirmButton: false,
                        timer: 1500,
                        position: 'bottom-end',
                        toast: true
                    });

                    resolve();
                } else {
                    // Create a new question via API
                    const formData = new FormData();
                    formData.append('question', this.newQuestion.text);
                    formData.append('question_type', this.newQuestion.type);
                    formData.append('question_number', this.newQuestion.question_number);
                    formData.append('is_mandatory', this.newQuestion.is_mandatory);

                    // Add options if any
                    if (this.newQuestion.options && this.newQuestion.options.length > 0) {
                        this.newQuestion.options.forEach(option => {
                            if (option.text && option.text.trim() !== "") {
                                formData.append('options', option.text.trim());
                            }
                        });
                    }

                    Swal.fire({
                        title: 'Creating question...',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });

                    $.ajax({
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_question/`,
                        method: "POST",
                        headers: { Authorization: `Token ${this.getToken()}` },
                        data: formData,
                        processData: false,
                        contentType: false,
                        success: (response) => {
                            if (response.status === "success") {
                                const newQuestion = response.question_data;

                                // Add to selected questions
                                if (newQuestion && newQuestion.id) {
                                    this.selectedQuestions.push({
                                        id: newQuestion.id,
                                        question: newQuestion.question
                                    });

                                    // Add to created questions list for display
                                    this.createdQuestions.push({
                                        text: newQuestion.question,
                                        id: newQuestion.id,
                                        type: newQuestion.question_type.id,
                                        is_mandatory: newQuestion.is_mandatory || false,
                                    });

                                    // Show success message
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Question Created',
                                        text: 'New question has been created and added to your survey',
                                        showConfirmButton: false,
                                        timer: 1500,
                                        position: 'bottom-end',
                                        toast: true
                                    });

                                    // Reset the form for the next question
                                    this.newQuestion = {
                                        text: '',
                                        question_number: '',
                                        type: '',
                                        options: [],
                                        is_mandatory: false,
                                    };

                                    // Refresh questions list
                                    this.fetchQuestions();

                                    // Resolve the promise with the new question
                                    resolve(newQuestion);
                                } else {
                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'Question Created',
                                        text: 'Question was created but could not be added to survey. Please try again.',
                                        position: 'bottom-end',
                                        showConfirmButton: false,
                                        timer: 3000,
                                        toast: true
                                    });
                                    reject('Question created but missing ID');
                                }
                            } else {
                                reject('Failed to create question');
                            }
                        },
                        error: () => {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: 'Failed to create question on survey.',
                                showConfirmButton: false,
                                timer: 1500,
                                position: 'bottom-end',
                                toast: true
                            });
                            reject('Failed to create question');
                        }
                    });
                }
            });
        },

        getQuestionTypeName(typeId) {
            if (!typeId) return 'Unknown';

            const questionType = this.question_types.find(type => type.id === typeId);
            return questionType ? questionType.question_type : 'Unknown';
        },
        addOption() {
            if (!Array.isArray(this.newQuestion.options)) {
                this.newQuestion.options = [];
            }

            const newOption = { id: Date.now(), text: '' };
            this.newQuestion.options.push(newOption);
        },
        removeOption(index) {
            this.newQuestion.options.splice(index, 1);
        },
        deleteSurvey(survey_id) {
            Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                position: 'bottom-end',
                toast: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        type: "DELETE",
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/delete_survey/`,
                        data: JSON.stringify({ survey_id: survey_id }),
                        headers: {
                            'Authorization': `Token ${this.getToken()}`,
                            'Content-Type': 'application/json'
                        },
                        success: (response) => {
                            const status = response.status;
                            if (status === "success") {
                                this.surveys = this.surveys.filter(survey => survey.id !== survey_id);
                                Swal.fire({
                                    title: 'Deleted!',
                                    text: 'The survey has been deleted.',
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 1000,
                                    position: 'bottom-end',
                                    toast: true
                                })
                            } else {
                                Swal.fire({
                                  title: 'Failed!',
                                  text: response.message || 'An error occurred. Please try again.',
                                  icon: 'error',
                                  position: 'bottom-end',
                                  showConfirmButton: false,
                                  timer: 3000,
                                  toast: true
                                });
                            }
                        },
                        error: (xhr) => {
                            Swal.fire({
                              title: 'Failed!',
                              text: xhr.responseJSON?.message || 'An error occurred. Please try again.',
                              icon: 'error',
                              position: 'bottom-end',
                              showConfirmButton: false,
                              timer: 3000,
                              toast: true
                            });
                        }
                    });
                }
            });
        },
        async addQuestionToPoll() {
            if (!this.newQuestion.text || !this.newQuestion.type || !this.newQuestion.question_number) {
                Swal.fire({
                    icon: 'error',
                    title: 'Missing Information',
                    text: 'Please fill in all required fields for the question',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                });
                return;
            }

            // Check if the question already exists
            const existingQuestion = this.questions.find(q => q.question === this.newQuestion.text);
            if (existingQuestion) {
                if (!this.selectedQuestions.some(q => q.id === existingQuestion.id)) {
                    this.selectedQuestions.push(existingQuestion);
                    this.createdQuestions.push({
                        text: existingQuestion.question,
                        id: existingQuestion.id,
                        type: existingQuestion.question_type.id,
                        is_mandatory: existingQuestion.is_mandatory || false,
                    });
                }

                // this.resetNewQuestionForm();

                Swal.fire({
                    icon: 'success',
                    title: 'Question Added',
                    text: 'Existing question has been added to your survey',
                    showConfirmButton: false,
                    timer: 1500,
                    position: 'bottom-end',
                    toast: true
                });

                return;
            }

            // Prepare form data for new question
            const formData = new FormData();
            formData.append('question', this.newQuestion.text);
            formData.append('question_type', this.newQuestion.type);
            formData.append('question_number', this.newQuestion.question_number);
            formData.append('is_mandatory', this.newQuestion.is_mandatory);

            if (this.newQuestion.options && this.newQuestion.options.length > 0) {
                this.newQuestion.options.forEach(option => {
                    if (option.text && option.text.trim() !== "") {
                        formData.append('options', option.text.trim());
                    }
                });
            }

            Swal.fire({
                title: 'Creating question...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            try {
                const response = await $.ajax({
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_question/`,
                    method: "POST",
                    headers: { Authorization: `Token ${this.getToken()}` },
                    data: formData,
                    processData: false,
                    contentType: false
                });

                if (response.status === "success" && response.question_data?.id) {
                    const newQuestion = response.question_data;

                    this.selectedQuestions.push({
                        id: newQuestion.id,
                        question: newQuestion.question
                    });

                    this.createdQuestions.push({
                        text: newQuestion.question,
                        id: newQuestion.id,
                        type: newQuestion.question_type.id,
                        is_mandatory: newQuestion.is_mandatory || false,
                    });

                    Swal.fire({
                        icon: 'success',
                        title: 'Question Created',
                        text: 'New question has been created and added to your survey',
                        showConfirmButton: false,
                        timer: 1500,
                        position: 'bottom-end',
                        toast: true
                    });

                    this.resetNewQuestionForm();
                    this.fetchQuestions();
                } else {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Question Created',
                        text: 'Question was created but could not be added to survey. Please try again.',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to create question.',
                    showConfirmButton: false,
                    timer: 1500,
                    position: 'bottom-end',
                    toast: true
                });
            }
        },

        validationforPollName() {
            this.errors = {};
            let valid = true;
            if (!this.poll_name || this.poll_name.trim() === '') {
                this.errors.poll_name = 'Poll name is required';
                valid = false;
            }
            if (!this.poll_question || this.poll_question.trim() === '') {
                this.errors.poll_question = 'A question is required';
                valid = false;
            }
            const hasAtLeastOneAnswer = this.options.some(
                option => option.value && option.value.trim() !== ''
            );
            if (!hasAtLeastOneAnswer) {
                this.errors.poll_answer = 'At least one answer option is required';
                valid = false;
            }
            return valid;
        },
        submitPollForm() {
            if (!this.validationforPollName()) {
                return;
            }
            const answers = this.options
                .map((option, index) => ({ text: option.value?.trim(), order: index + 1 }))
                .filter(answer => answer.text);

            const group_id = this.$route.params.group_id;
            const portal_id = this.$route.params.portal_id;

            const payload = {
                poll_name: this.poll_name,
                group_id: group_id ? Number(group_id) : null,
                portal_id: group_id ? null : (portal_id ? Number(portal_id) : null),
                questions: [
                    {
                        question_text: this.poll_question,
                        question_type: this.allowMultiple ? "selection" : "checkbox",
                        options: answers
                    }
                ]
            };

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/create_poll/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload),
                success: () => {
                    Swal.fire({
                        title: 'Creating poll...',
                        allowOutsideClick: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    Swal.close();

                    this.filter_polls();
                    Swal.fire({
                        icon: 'success',
                        title: 'Poll Created',
                        text: 'Your poll has been successfully created!',
                        showConfirmButton: false,
                        timer: 2000,
                        position: 'bottom-end',
                        toast: true
                    }).then(() => {
                        this.resetPollForm();
                        this.activeVoiceTab = 'polls';
                    });
                },

                error: (xhr) => {
                    Swal.close();

                    this.errors.poll_name = xhr.responseJSON.message

                }
            });
        },

        resetPollForm() {
            this.poll_name = "";
            this.poll_question = "";
            this.poll_description = "";
            this.allowMultiple = false;
            this.options = [{ value: "" }, { value: "" }, { value: "" }];
        },

        filter_polls() {
            const group_id_param = this.$route.params.group_id;
            const portal_id_param = this.$route.params.portal_id;

            const group_id = group_id_param ? Number(group_id_param) : null;
            const portal_id = group_id ? null : (portal_id_param ? Number(portal_id_param) : null);
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/filter_poll/`,
                method: 'POST',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify({ portal_id, group_id }),
                success: (response) => {
                    this.polls = response.data;

                    this.initializeAnswers();

                },
                complete: () => {
                    this.isLoading = false;
                }
            });
        },

        togglePoll(id) {
            this.selectedPollId = this.selectedPollId === id ? null : id;
        },
        toggleCheckboxAnswerP(poll, questionId, option, isChecked) {
            this.poll_questions = poll.poll_questions;
            const question = this.poll_questions.find(q => q.question.id === questionId);

            if (question) {
                if (!Array.isArray(question.answer)) {
                    question.answer = [];
                }

                if (isChecked) {
                    if (!question.answer.includes(option)) {
                        question.answer.push(option);
                    }
                } else {
                    const index = question.answer.indexOf(option);
                    if (index !== -1) {
                        question.answer.splice(index, 1);
                    }
                }

                this.answers = {
                    ...this.answers,
                    [questionId]: question.answer.slice()
                };
            }
        },
        submitPollAnswers(poll) {
            if (poll?.creater?.id === Number(this.user_id)) {
                Swal.fire({
                    icon: 'info',
                    title: 'Creator polls are view-only',
                    text: 'You cannot vote on a poll you created.',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 2500,
                    toast: true
                });
                return;
            }

            const formData = new FormData();
            formData.append('poll_id', poll.id);

            const answeredQuestions = [];
            this.pollErrors = [];
            this.firstPollErrorQuestionId = null;

            const validPollQuestionIds = Array.isArray(poll.poll_questions)
                ? poll.poll_questions.map(question => question?.question?.id).filter(Boolean)
                : [];

            // ✅ Iterate through valid question IDs
            validPollQuestionIds.forEach(questionId => {
                let answer;

                if (this.answers instanceof Map) {
                    answer = this.answers.get(questionId); // Map still uses get()
                } else {
                    // Use Reflect.get for plain objects
                    answer = Reflect.get(this.answers, questionId);
                } // fallback if it's still an object


                const isEmpty =
                    answer === undefined ||
                    answer === null ||
                    (Array.isArray(answer) && answer.length === 0) ||
                    (typeof answer === 'string' && answer.trim() === '');

                if (isEmpty) {
                    if (!this.firstPollErrorQuestionId) this.firstPollErrorQuestionId = questionId;
                    const exists = this.pollErrors.find(error => error.id === questionId);
                    if (!exists) {
                        this.pollErrors.push({
                            id: questionId,
                            message: 'This poll must be answered.'
                        });
                    }
                } else {
                    answeredQuestions.push({
                        question_id: Number(questionId),
                        answer: Array.isArray(answer) ? answer.join(',') : answer
                    });
                }
            });

            if (this.pollErrors.length > 0) return;

            formData.append('answers', JSON.stringify(answeredQuestions));

            $.ajax({
                type: "POST",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/answer_poll/`,
                headers: {
                    'Authorization': `Token ${this.getToken()}`
                },
                data: formData,
                processData: false,
                contentType: false,
                beforeSend: () => {
                    this.isSubmitting = true;
                    Swal.fire({
                        title: 'Submitting your answers...',
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading()
                    });
                },
                success: (response) => {
                    Swal.close();
                    if (response.status === 'success') {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Your answers have been submitted successfully!',
                            showConfirmButton: false,
                            timer: 1500,
                            position: 'bottom-end',
                            toast: true
                        });
                        this.selectedPollId = null;
                        poll.poll_questions.forEach(q => {
                            const submitted = this.answers[q.question.id];
                            if (submitted) {
                                const current_user_id = Number(this.user_id);
                                const existing_answers = Array.isArray(q.answers) ? [...q.answers] : [];
                                const existing_answer = existing_answers.find(answer => {
                                    const answer_user_id = Number(
                                        answer?.user?.id ??
                                        answer?.user_id ??
                                        answer?.creator?.id ??
                                        answer?.creator_id
                                    );
                                    return answer_user_id === current_user_id;
                                });
                                const existing_index = existing_answers.indexOf(existing_answer);

                                const local_answer = {
                                    id: existing_answer?.id,
                                    answer: submitted,
                                    user_id: current_user_id,
                                    user: {
                                        id: current_user_id
                                    }
                                };

                                if (existing_index >= 0) {
                                    existing_answers.splice(existing_index, 1, local_answer);
                                } else {
                                    existing_answers.push(local_answer);
                                }

                                q.answers = existing_answers;
                            }
                        });
                        poll.is_answered = true;
                    }
                },
                error: () => {
                    Swal.close();
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong. Please try again later.',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                },
                complete: () => {
                    this.showQuestionsForm = false;
                    this.isSubmitting = false;
                },
            });
        },

        togglePollResponses(id) {
            this.showResponsesFor = this.showResponsesFor === id ? null : id;
        },
        toggleQuestionResponses(questionId) {
            const currentValue = this.expandedQuestions.get(questionId);
            this.expandedQuestions.set(questionId, !currentValue);
        },
        editPoll(poll) {
            this.resetPollForm();

            this.errors = {};
            this.poll_id = poll.id;
            this.poll_name = poll.name;
            this.description = poll.description || '';

            const firstQuestion = poll.poll_questions?.[0]?.question;

            if (firstQuestion) {
                this.poll_question = firstQuestion.question || '';

                const questionType = firstQuestion.question_type?.question_type?.toLowerCase();
                this.allowMultiple = questionType === 'selection';

                this.options = firstQuestion.options?.map(opt => ({
                    value: opt.option || opt.text || ''
                })) || [];
            }

            this.activeVoiceTab = 'questionpoll';
            this.showPollCreation = true;

            this.$nextTick(() => {
                if (this.$refs.quillPollEditorRef) {
                    this.$refs.quillPollEditorRef.setHTML(this.description);
                }
            });
        },

        cancelEditPoll() {
            this.poll_id = null;
            this.poll_name = '';
            this.description = '';
            this.selectedQuestions = [];
            this.createdQuestions = [];
            if (this.$refs.quillPollEditorRef) {
                this.$refs.quillPollEditorRef.setHTML('');
            }

            // Switch back to polls tab
            this.activeVoiceTab = 'polls';
        },

        updatePoll() {
            this.poll_description = this.description || 'no description';

            this.poll_description = this.poll_description.replace(/<\/?p>/g, '').trim();

            if (!this.poll_description || this.poll_description === '<br>' || this.poll_description === '<br/>') {
                this.poll_description = '';
            }

            if (this.newQuestion.text && this.newQuestion.type) {

                this.addQuestionToPoll()
                    .then(() => {
                        this.updatePollForm();
                    })
                    .catch((error) => {
                        console.error("Error adding question:", error);
                    });
                return;
            }
            this.updatePollForm();
        },
        updatePollForm() {
            const questionType = this.question_types.find(question_type =>
                question_type.question_type.toLowerCase() === (this.allowMultiple ? 'selection' : 'checkbox')
            );
            const question_type_id = questionType?.id || null;

            const answers = this.options
                .map(option => option.value?.trim())
                .filter(Boolean);

            const payload = {
                poll_id: this.poll_id,
                name: this.poll_name,
                description: this.poll_description || '',
                questions: [
                    {
                        question: this.poll_question,
                        question_type: question_type_id,
                        question_number: 1,
                        is_mandatory: false,
                        options: answers
                    }
                ]
            };

            Swal.fire({
                title: 'Updating poll...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/update_poll/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload),
                success: () => {
                    this.filter_polls();
                    Swal.fire({
                        icon: 'success',
                        title: 'Poll Updated',
                        text: 'Your poll has been successfully updated!',
                        showConfirmButton: false,
                        timer: 2000,
                        position: 'bottom-end',
                        toast: true
                    }).then(() => {
                        this.resetPollForm();
                        this.activeVoiceTab = 'polls';
                    });
                },
                error: (xhr) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Cannot Edit Poll',
                        text: xhr.responseJSON?.message || 'Poll already answered or invalid data.',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                }
            });
        },
        deletePoll(poll_id) {
            Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                position: 'bottom-end',
                toast: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        type: "DELETE",
                        url: `${process.env.VUE_APP_BACKEND_API_URL}/survey_management/delete_poll/`,
                        data: JSON.stringify({ poll_id: poll_id }),
                        headers: {
                            'Authorization': `Token ${this.getToken()}`,
                            'Content-Type': 'application/json'
                        },
                        success: (response) => {
                            const status = response.status;
                            if (status === "success") {
                                this.polls = this.polls.filter(poll => poll.id !== poll_id);
                                Swal.fire({
                                    title: 'Deleted!',
                                    text: 'The poll has been deleted.',
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 1000,
                                    position: 'bottom-end',
                                    toast: true
                                })
                            } else {
                                Swal.fire({
                                  title: 'Failed!',
                                  text: response.message || 'An error occurred. Please try again.',
                                  icon: 'error',
                                  position: 'bottom-end',
                                  showConfirmButton: false,
                                  timer: 3000,
                                  toast: true
                                });
                            }
                        },
                        error: (xhr) => {
                            Swal.fire({
                              title: 'Failed!',
                              text: xhr.responseJSON?.message || 'An error occurred. Please try again.',
                              icon: 'error',
                              position: 'bottom-end',
                              showConfirmButton: false,
                              timer: 3000,
                              toast: true
                            });
                        }
                    });
                }
            });
        },
        openPollResponses(poll) {
            this.selectedPoll = poll;
            $('#pollResponsesModal').modal('show');
        },
        get_poll_answer_count(poll) {
            let total = 0;
            poll.poll_questions.forEach(question => {
                if (Array.isArray(question.answers)) {
                    total += question.answers.length;
                }
            });
            return total;
        },

        exportPollToCSV() {
            const poll = this.selectedPoll;

            // 1. Validation
            if (!poll || !poll.poll_questions || poll.poll_questions.length === 0) {
                Swal.fire({
                    icon: "warning",
                    text: "No poll data available for export.",
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                });
                return;
            }

            // 2. Define Header
            // We want to know: Who voted, what was the question, and what was their choice.
            let csvHeader = "Voter Name,Question,Option Selected\n";

            // 3. Process Rows
            const csvRows = [];

            poll.poll_questions.forEach(q => {
                // We iterate through each question's answers
                q.answers.forEach(ans => {
                    // Handle the user name logic (matching your modal display)
                    const firstName = ans.user?.first_name || "";
                    const lastName = ans.user?.last_name || "";
                    const fullName = ans.user?.is_blocked
                        ? "Unknown User"
                        : `${firstName} ${lastName}`.trim() || "Anonymous";

                    const questionText = q.question?.question || "N/A";
                    const selectedOption = ans.answer || "N/A"; // The text value of the vote


                    // Wrap fields in double quotes to prevent commas in text from breaking columns
                    const row = `"${fullName}","${questionText.replace(/"/g, '""')}","${selectedOption.replace(/"/g, '""')}"`;

                    csvRows.push(row);
                });
            });

            // 4. Check if we actually have votes
            if (csvRows.length === 0) {
                Swal.fire({
                    icon: "warning",
                    text: "This poll has no responses yet.",
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true
                });
                return;
            }

            // 5. Create and Download File
            const csvContent = csvHeader + csvRows.join("\n");
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            // Use poll name for the filename
            a.download = (poll.name || "poll_export").replace(/\s+/g, "_") + ".csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
    }
};
